import { gql } from '@apollo/client';
import { SaveDriverActivityInput, UpdateDriverActivityLimitedInput } from './types';

export const SAVE_DRIVER_ACTIVITY_DRAFT = gql`
    mutation SaveDriverActivityDraft($input: SaveDriverActivityInput!) {
        saveDriverActivityDraft(input: $input)
    }
`;

export interface SaveDriverActivityDraftResponse {
    saveDriverActivityDraft: number;
}

export const SUBMIT_DRIVER_ACTIVITY_ONLINE = gql`
    mutation SubmitDriverActivityOnline($input: SaveDriverActivityInput!) {
        submitDriverActivityOnline(input: $input)
    }
`;

export interface SubmitDriverActivityOnlineResponse {
    submitDriverActivityOnline: number;
}

export interface SaveDriverActivityVariables {
    input: SaveDriverActivityInput;
}

export const UPDATE_DRIVER_ACTIVITY_LIMITED = gql`
    mutation UpdateDriverActivityLimited($input: UpdateDriverActivityLimitedInput!) {
        updateDriverActivityLimited(input: $input)
    }
`;

export interface UpdateDriverActivityLimitedResponse {
    updateDriverActivityLimited: boolean;
}

export interface UpdateDriverActivityLimitedVariables {
    input: UpdateDriverActivityLimitedInput;
}

export const OFFLINE_DRIVER_ACTIVITY = gql`
    mutation OfflineDriverActivity($id: Long!, $reason: String!) {
        offlineDriverActivity(id: $id, reason: $reason)
    }
`;

export interface OfflineDriverActivityResponse {
    offlineDriverActivity: boolean;
}

export interface OfflineDriverActivityVariables {
    id: number;
    reason: string;
}

export const DELETE_DRIVER_ACTIVITY_DRAFT = gql`
    mutation DeleteDriverActivityDraft($id: Long!) {
        deleteDriverActivityDraft(id: $id)
    }
`;

export interface DeleteDriverActivityDraftResponse {
    deleteDriverActivityDraft: boolean;
}

export interface DeleteDriverActivityDraftVariables {
    id: number;
}
